var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: _vm.ref, staticClass: "dataview-select-lines" }, [
    _c(
      "svg",
      { attrs: { width: _vm.realWidth, height: _vm.realHeight } },
      [
        _c("defs", [
          _c(
            "marker",
            {
              attrs: {
                id: "arrow",
                markerUnits: "strokeWidth",
                markerWidth: "12",
                markerHeight: "12",
                viewBox: "0 0 12 12",
                refX: "6",
                refY: "6",
                orient: "auto",
              },
            },
            [
              _c("path", {
                staticStyle: { fill: "red" },
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  d: "M2,2 L10,6 L2,10 L6,6 L2,2",
                },
              }),
            ]
          ),
        ]),
        _vm._l(_vm.lines, function (it, index) {
          return _c("line", {
            key: index,
            attrs: {
              x1: it.start.x,
              y1: it.start.y,
              x2: it.end.x,
              y2: it.end.y,
              stroke: "red",
              "marker-end": "url(#arrow)",
              "stroke-width": "2",
              "stroke-dasharray": "10,10",
            },
          })
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }